import React, { useState } from 'react'
import { Alert, Button, Form, Input, Modal, Progress, Select } from 'antd';
import { addClassProps } from './addclass-interface';
import { createClass } from '../../../../../api/class/class';
import { openNotificationWithIcon } from '../../../../../utils/helper';

const { Option } = Select

const Addclass = ({ open, closeModal, loadingLanguages, languages }: addClassProps) => {
	const [form] = Form.useForm();

	// eslint-disable-next-line 
	const [stageOneData, setStageOneData] = useState({
		name: "",
		description: "",
		languageId: "",
	})
	const currentStage = 1
	// const [currentStage, setCurrentStage] = useState(1)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState<any>(null)
	const [errors, setErrors] = useState({
		name: "",
		description: "",
		languageId: "",
	})

	const onFinish = async (values: any) => {
		try {
			setLoading(true)
			setError(null)
			setErrors(prevState => ({
				...prevState,
				name: "",
				description: "",
				languageId: "",
			}))

			const res = await createClass({ ...values })

			const { message } = res.data

			openNotificationWithIcon("success", "Add Class", message || 'Class created successfully')
			setLoading(false)
			closeModal(true)

		} catch (error: any) {
			setLoading(false)
			const otherErrors: any[] = []
			if (error?.response) {
				if (error?.response?.data?.errors) {
					const resError = error?.response?.data?.errors

					Object.entries(resError).forEach(([key, value]) => {
						if (Object.keys(errors).includes(key)) {
							setErrors(prevState => ({
								...prevState,
								[key]: value
							}))
						} else {
							otherErrors.push(value)
						}
					})

					if (otherErrors.length > 0) {
						const errorList = otherErrors.map((element: any, index) => {
							return <li key={`error-list-${index}`}>{element}</li>
						});
						setError(errorList)
					}

				} else {
					setError(error?.response?.data?.message || 'Something went wrong')
				}
			} else {
				setError('Something went wrong')
			}
		}
	}


	return (
		<div>
			<Modal
				closable={false}
				open={open}
				onOk={() => {
					if (!loading) {
						closeModal()
					}
				}}
				onCancel={() => {
					if (!loading) {
						closeModal()
					}
				}}
				footer={null}
				width={'38rem'}
				className='white-bg-modal'
			>
				<div>
					<div className='flex border-b border-appcolorgreyfour pb-[0.75rem] justify-between items-center'>
						<h1 className='text-[22px] leading-[110%] font-semibold text-appcolorgrey mb-[-1rem]'>Add Class</h1>
						<div className='rounded-full bg-appcolorgreyfive custom-box-shadow-five p-[0.9rem] w-fit cursor-pointer'
							onClick={() => {
								if (!loading) {
									closeModal()
								}
							}}
						>
							<img src="/img/vectors/modalclose.svg" alt="" />
						</div>
					</div>

					<div className='pt-2'>
						<Progress
							percent={100 * currentStage}
							status="normal"
							showInfo={false}
						/>

						<p className='text-sm text-appcolorgrey'>Step {currentStage} of 1</p>

						<div className='flex items-center justify-between'>
							<p className='text-lg font-bold'>
								{
									currentStage === 1 ?
										'General Info' : ''
								}
							</p>
						</div>
					</div>

					<div className='mt-[2rem]'>
						{
							error !== null ?
								<div className='mb-4'>
									<Alert message={error} type="error" />
								</div>
								: null
						}


						{
							currentStage === 1 ?
								<Form
									layout="vertical"
									onFinish={onFinish}
									form={form}
									initialValues={{
										...stageOneData
									}}
								>
									<Form.Item
										label="Name"
										name="name"
										rules={[{ required: true, message: 'Input is required' }]}
										validateStatus={errors?.name.length > 0 ? 'error' : undefined}
										help={errors?.name.length > 0 ? errors?.name : undefined}
									>
										<Input
											onChange={() => {
												setErrors(prevState => ({
													...prevState,
													name: '',
												}))
											}}
											placeholder="Enter a name for your class"
										/>
									</Form.Item>

									<div id="select-language-area">
										<Form.Item
											label="Language"
											name="languageId"
											rules={[{ required: true, message: 'Input is required' }]}
											validateStatus={errors?.languageId.length > 0 ? 'error' : undefined}
											help={errors?.languageId.length > 0 ? errors?.languageId : undefined}
										>
											<Select
												placeholder="What language would you be teaching? "
												loading={loadingLanguages}
												//@ts-ignore
												getPopupContainer={() => document.getElementById('select-language-area')}
												className='capitalize'
											>
												{
													languages.map((item) => (
														<Option key={item?._id} value={item?._id} className="capitalize"
														>
															{item.name}
														</Option>
													))
												}
											</Select>
										</Form.Item>
									</div>

									<Form.Item
										label="Description"
										name="description"
										rules={[{ required: true, message: 'Input is required' }]}
										validateStatus={errors?.description.length > 0 ? 'error' : undefined}
										help={errors?.description.length > 0 ? errors?.description : undefined}
									>
										<Input
											onChange={() => {
												setErrors(prevState => ({
													...prevState,
													description: '',
												}))
											}}
											placeholder="Enter a description for your class"
										/>
									</Form.Item>

									<div className='mt-[2.5rem] flex justify-end'>
										<Button
											onClick={() => {
												if (!loading) {
													closeModal()
												}
											}}
											style={{
												color: '#200E32 !important'
											}}
											disabled={loading}
											className='mr-[0.9rem] custom-white-btn black-text smaller-padding'>

											Cancel
										</Button>

										<Button
											disabled={loading}
											className='custom-primary-two-btn smaller-padding'
											loading={loading}
											htmlType='submit'
										>
											Continue
										</Button>
									</div>
								</Form>
								:
								null
						}

					</div>
				</div>
			</Modal>
		</div>
	)
}

export default Addclass